import { slugs } from '@/constants/slugs'
import { TranslateFunction } from '@/utils/translate/translate-client'
import { getTruthAndTreasonConfig } from '@/views/PreSales/PreSalesGiveawayView/config/giveaway-prizes/projects/truth-and-treason'
import { GiveawayPrizeItem } from '../types'
import {
  getLastRodeoConfig,
  getKingOfKingsConfig,
  getSketchConfig,
  getYoungWashingtonConfig,
  getSeniorConfig,
  getDavidConfig,
  getIwasConfig,
} from './projects'

export interface PrizeConfig {
  grandPrizes?: GiveawayPrizeItem[]
  firstPlacePrizes?: GiveawayPrizeItem[]
  secondPlacePrizes?: GiveawayPrizeItem[]
  prizes?: GiveawayPrizeItem[]
  numberOfWinners?: {
    firstPlace?: string
    secondPlace?: string
  }
  grandPrizeText?: string
  firstPlaceText?: string
  secondPlaceText?: string
}
const PRIZE_CONFIGS: Record<string, (t?: TranslateFunction) => PrizeConfig> = {
  [slugs.kingOfKings]: getKingOfKingsConfig,
  [slugs.theLastRodeo]: getLastRodeoConfig,
  [slugs.sketch]: getSketchConfig,
  [slugs.senior]: getSeniorConfig,
  [slugs.youngWashington]: (t?: TranslateFunction) => getYoungWashingtonConfig(t!),
  [slugs.truthAndTreason]: getTruthAndTreasonConfig,
  [slugs.david]: getDavidConfig,
  [slugs.iWasAStranger]: getIwasConfig,
}

export const getPrizeConfig = (theatricalSlug: string, t?: TranslateFunction): PrizeConfig | null => {
  const configFactory = PRIZE_CONFIGS[theatricalSlug]
  return configFactory ? configFactory(t) : null
}
